module.exports = __webpack_public_path__ + "./kit/docs/img/icon-git-gray.1202899373f6b000868c840eb1f62e89.svg";